import { isValidEmailAddress, isValidPassword, number_format } from '../functions';


$(document).ready(function() {

	$(document).on('click', '.refresh-shipping-fee-btn', function() {

		if($('#shipping-method-id option:selected').val() == '') {
			Swal.fire({
				//icon: "success",
				title: "Eroare!",
				html: 'Va rugam selectati metoda de livrare!'
			});
			return;
		}

		var values = '_token=' + $('meta[name="csrf-token"]').attr('content');
        values += '&city_id=' + $('#shopping-cart-cities option:selected').val();
        values += '&shipping_method_id=' + $('#shipping-method-id option:selected').val();
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/get-shipping-fee",
            data: values,
            success: function(response) {
                if (response.status == 1) {
					$('.shopping-cart-amount-to-free-shipping .amount').text(response.amount_to_free_shipping);
				    if (1*response.amount_to_free_shipping <= 0) {
				        $('.shopping-cart-amount-to-free-shipping').hide();
				    } else {
				        $('.shopping-cart-amount-to-free-shipping').show();
				    }

					$('.shipping-amount').html(1*response.shipping_amount > 0 ? response.shipping_amount + ' LEI' : 'Gratuit');
				    $('.shoppingcart-main-total').html(response.total + ' LEI');
                }
            },
            error(error) {

            }
        });
	});

	$('#shopping-cart-cities').select2({
		placeholder: 'Cauta orasul',
  		minimumInputLength: 3,
		language: {
		    inputTooShort: function() {
		        return 'Va rugam introduceti cel putin 3 litere';
		    }
		},
		ajax: {
			url: baseURL + "/get-cities",
			dataType: 'json'
			// Additional AJAX parameters go here; see the end of this chapter for the full code of this example
		}
	});

    $(document).on("input", "#product-cart-quantity-input", function () {
        this.value = this.value.replace(/[^0-9\+\-]/g, '');
    });
    // Upadte product in qty - add
    $('.product-cart-quantity-plus').click(function (e) {
        e.preventDefault();
        var quantity = $('#product-cart-quantity-input').val();
        $('#product-cart-quantity-input').val(parseInt(quantity) + 1);
    });

    // Upadte product in qty - reduce
    $('.product-cart-quantity-minus').click(function (e) {
        e.preventDefault();
        var quantity = $('#product-cart-quantity-input').val();
        if (quantity > 0)
            $('#product-cart-quantity-input').val(parseInt(quantity) - 1);
    });

    $(document).on('click', '#add-to-cart', function(e) {
        e.preventDefault();

        var id = $(this).data('id');
        if (!id) { console.log('invalid-id'); return false; }

		var qty = $('#quantity option:selected').val();
		if (1*qty < 1) {
			alert('Invalid quantity!');
			return false;
		}

        var values = '_token=' + $('#_token_add_cart').val();
        values += '&id=' + id;
        values += '&qty=' + qty;
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/add",
            data: values,
            success: function(response) {
                if (response.status == 1) {
                    window.location = baseURL + "/cart";
                    return;
                }

                Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {

            }
        });
    });

    $(document).on('click', '.add-to-cart', function(e) {
        e.preventDefault();

        var id = $(this).data('id');
        if (!id) { console.log('invalid-id'); return false; }

        var values = '_token=' + $('meta[name="csrf-token"]').attr('content');
        values += '&id=' + id;
        values += '&qty=' + 1;
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/add",
            data: values,
            success: function(response) {
                if (response.status == 1) {
                    //window.location = baseURL + "/cart";
					productHTML(response.product);
					refreshCartSummary(response);
                    return;
                }

                Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {

            }
        });
    });

    $(document).on('click', '.shoppingcart-item-remove', function (e) {
        e.preventDefault();

        var id = $(this).data('id');
        var source = $(this).data('source');
        if (!id) { return false; }

        var values = '_token=' + $('meta[name="csrf-token"]').attr('content');
        values += '&id=' + id;
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/remove",
            data: values,
            success: function(response) {
                if (response.status == 1) {
                    if (response.cart_items_count < 1 && $('#cart-page-items').length > 0) {
                        location.reload();
                        return;
                    }

                    refreshCartSummary(response);
					refreshGifts();

                    $('#shoppingcart-item-' + id).remove();
                    $('#page-cart-item-' + id).remove();

                    if (source == 'sidecart') {
                        $('.sidebar-cart-count').text(response.cart_items_count);
                        $('.sidebar-cart-total').text(response.data.subtotal + ' LEI');
                        $('.sidebar-cart-total-without-vat span').text(number_format(response.data.subtotal_without_vat, 2, '.', ''));
                    }
                }
            },
            error(error) {

            }
        });
    });

    $(document).on('click', '.cart-item-quantity-plus', function (e) {
        e.preventDefault();

        var id = $(this).data('id');
        if (!id) { return false; }

        var values = '_token=' + $('#_token_page_cart').val();
        values += '&id=' + id;
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/increase-qty",
            data: values,
            success: function(response) {
                if (response.status == 1) {

                    refreshCartSummary(response);
					refreshGifts();

                    var newPrice = 1*response.data.item.qty*1*response.data.item.price;

                    $('.page-cart-item-quantity-input-' + id).val(response.data.item.qty);
                    $('.page-cart-item-price-' + id).html(number_format(newPrice, 2, '.', ' '));
                    $('.page-cart-item-price-no-vat-' + id).html(number_format(1*response.data.item.price_without_vat, 2, '.', ' '));

                    return;
                }

                Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {

            }
        });
    });

    $(document).on('click', '.cart-item-quantity-minus', function (e) {
        e.preventDefault();

        var id = $(this).data('id');
        if (!id) { return false; }

        var values = '_token=' + $('#_token_page_cart').val();
        values += '&id=' + id;
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/decrease-qty",
            data: values,
            success: function(response) {
                if (response.status == 1) {

                    refreshCartSummary(response);

                    if (response.data.status == 'removed') {

                        if (response.cart_items_count < 1) {
                            location.reload();
                            return;
                        }

						$('#shoppingcart-item-' + id).remove();
	                    $('#page-cart-item-' + id).remove();
                    } else {

                        var newPrice = 1*response.data.item.qty*1*response.data.item.price;

                        $('.page-cart-item-quantity-input-' + id).val(response.data.item.qty);
                        $('.page-cart-item-price-' + id).html(number_format(newPrice, 2, '.', ' '));
                        $('.page-cart-item-price-no-vat-' + id).html(number_format(1*response.data.item.price_without_vat, 2, '.', ' '));
                    }

					refreshGifts();
                    //console.log(response);

                    return;
                }

                Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {

            }
        });
    });

    $(document).on('click', '.cart-page-apply-points', function(e) {
        e.preventDefault();

        let points = 1*$('#cart-points-user').val();

        if (!Number.isInteger(points)) {
            alert('Invalid number of points!');
            return false;
        }
        if (points < 1) {
            alert('You need to use at least one point!');
            return false;
        }

        var values = '_token=' + $('#_token_modal_cart').val();
        values += '&points=' + points;
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/apply-points",
            data: values,
            success: function(response) {
                if (response.status == 1) {
                    $('#cart-points-user').val(response.data.used_points);
                    $('.cart-points').html('-'+response.data.used_points);

                    $('.cart-points-input').slideUp();
                    $('.cart-points-text').slideDown();

                    refreshCartSummary(response.data);
                }
            },
            error(error) {

            }
        });
    });

    $(document).on('click', '.cart-page-remove-points', function(e) {
        e.preventDefault();

        var values = '_token=' + $('#_token_modal_cart').val();
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/remove-points",
            data: values,
            success: function(response) {
                if (response.status == 1) {
                    $('#cart-points-user').val(response.data.user_points);
                    $('.cart-points').html('-'+response.data.used_points);

                    $('.cart-points-input').slideDown();
                    $('.cart-points-text').slideUp();

                    refreshCartSummary(response.data);
                }
            },
            error(error) {

            }
        });
    });

    $(document).on('click', '.alert-gift-btn', function(e) {
		e.preventDefault();
		var text = $(this).data('alert-text');

		Swal.fire({
			width: "350px",
			//icon: "success",
			//title: "Success!",
			html: text
		});
	});

    $(document).on('click', '.select-gift-btn', function(e) {
        e.preventDefault();

		var id = $(this).data('id');
		var element = this;

		var action = 'select-gift';
		if ($(this).hasClass('active')) {
			action = 'remove-gift';
		}

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");
		values += '&id=' + id;
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/" + action,
            data: values,
            success: function(response) {
                if (response.status == 1) {
					$(element).removeClass('active');
					if (action == 'select-gift') {
						$(element).addClass('active');
					}
					return;
                }

				alert(response.message);
            },
            error(error) {

            }
        });
    });
});

function refreshGifts() {

	var values = '_token=' + $("meta[name='csrf-token']").attr("content");
	$.ajax({
		type: "POST",
		url: baseURL + "/cart/gifts",
		data: values,
		success: function(html) {
			$('#gifts-container').html(html);
		},
		error(error) {

		}
	});
}

function refreshCartSummary(data) {

	var giftsMinAmount = $('.gift-text-info').data('min-amount');
	var leftAmountForGift = 1*giftsMinAmount - 1*data.data.subtotal;
	$('.gifts-min-amount').text(number_format(leftAmountForGift,2,'.',''));
	if (leftAmountForGift < 1) {
		$('.gift-text-info').hide();
	} else {
		$('.gift-text-info').show();
	}

	$('.cart-points').text(data.data.points);
    $('.points-text-info').hide();
	if (data.data.points > 0) {
        $('.points-text-info').show();
	}

	$('.shoppingcart-count').text(data.cart_items_count);
	$('.header-cart-counting').text(data.cart_items_count);
    if (data.cart_items_count > 0) {
        $('#header-cart').find('.rounded-circle').show();
    } else {
        $('#header-cart').find('.rounded-circle').hide();
    }
    $('.shoppingcart-total-without-vat').html(number_format(data.data.subtotal_without_vat, 2, '.', ''));
    $('.shoppingcart-subtotal').html(number_format(1*data.data.subtotal, 2, '.', '') + ' LEI');
    $('.shoppingcart-main-total').html(number_format(data.data.total,2,'.','') + ' LEI');
    //$('.shoppingcart-total-without-vat').html(data.data.total_without_vat + ' lei');
    //$('.cart-page-main-total-amount').html(data.total);

	$('.shopping-cart-amount-to-free-shipping .amount').text(data.data.amount_to_free_shipping);
    if (1*data.data.amount_to_free_shipping <= 0) {
        $('.shopping-cart-amount-to-free-shipping').hide();
    } else {
        $('.shopping-cart-amount-to-free-shipping').show();
    }

	$('.shipping-amount').html(1*data.data.shipping_amount > 0 ? data.data.shipping_amount + ' Lei' : 'Gratuit');
}

function productHTML(data) {
	if ($('#shopping-cart-items-container').length > 0) {
		if ($('#shoppingcart-item-' + data.row_id).length > 0) {
			$('#shoppingcart-item-' + data.row_id).find('.nr-prod').html(data.qty + 'x');
			$('#shoppingcart-item-' + data.row_id).find('.price').html(data.price + ' lei');
			$('#shoppingcart-item-' + data.row_id).find('.no-tva').html(data.price_without_vat + ' lei fara TVA');
		} else {
			$('#shopping-cart-items-container').append(`<div class="wrap-product" id="shoppingcart-item-${data.row_id}">
				<a href="${data.url}" title="${data.name}" class="image">
					<img src="${data.image}" width="69" title="${data.name}" alt="${data.name}">
					<span class="nr-prod">${data.qty}x</span>
				</a>
				<div class="product-details">
					<p class="title">${data.name}</p>
					<p class="price">${data.price} lei</p>
					<p class="no-tva">${data.price_without_vat} lei fara TVA</p>
				</div>
				<a href="javascript:void(0)" data-id="${data.row_id}" class="delete shoppingcart-item-remove"><i class="fal fa-trash-alt"></i></a>
			</div>`);
		}
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/shopping-cart.js